<template>
  <div class="visitor">
    <van-nav-bar
      title="预约"
      right-text="我要预约"
      @click-right="clickNavBarRight"
    />
    <!-- <div class="visitor-top"></div> -->
    <div class="form-bg-title">
      <div class="img"></div>
      <!-- <div class="company">济南亚爱特软件有限公司</div>
      <div class="welcome">欢迎您</div> -->
    </div>
    <div class="list" v-if="list.length > 0">
      <div
        class="list-item"
        v-for="item in list"
        :key="item.id"
        @click="handleVisItem(item.id)"
      >
        <div class="top">
          <!-- <span class="status todo">待审批</span> -->
          <van-tag
            plain
            type="primary"
            size="medium"
            v-if="item.auditStatus == 0"
            >待审批</van-tag>
          <van-tag
            plain
            type="success"
            size="medium"
            v-if="item.auditStatus == 1"
            >已通过</van-tag
          >
          <van-tag
            plain
            type="danger"
            size="medium"
            v-if="item.auditStatus == -1"
            >已失效</van-tag
          >
          <van-tag
            plain
            type="danger"
            size="medium"
            v-if="item.auditStatus == 2"
            >已驳回</van-tag
          >
          <span class="top-text"
            >{{ item.resttime }} {{ item.startTime }} - {{ item.endTime }}</span
          >
        </div>
        <div class="content">
          <div class="avatar">
            <img :src="item.userPhoto" alt="" />
          </div>
          <div class="info">
            <div class="info-1">
              <div>{{ item.initiatorName }} {{ item.initiatorPhone }}</div>
              <div
                class="btn"
                v-if="item.auditStatus == 0"
                @click.stop="handleVisEdit(item.id)"
              >
                撤销
              </div>
            </div>
            <div class="info-2" v-if="item.affiliatedUnit">
              {{ item.affiliatedUnit }}
            </div>
          </div>
        </div>
        <div
          class="count"
          v-if="item.visitorName && item.visitorName.length > 0"
        >
          共计{{ item.visitorName && item.visitorName.length + 1 }}人：
          <span class="" v-for="(v, index) in item.visitorName"
            >{{ v
            }}<span v-if="index !== item.visitorName.length - 1">
              /
            </span></span
          >
        </div>
      </div>
    </div>
    <div v-else>
      <van-empty description="暂无数据" />
    </div>
    <!-- <div class="title">
      未审批
    </div>
    <div class="visitor-content">
      <div class="todo-list" v-if="visitorList.length > 0">
        <div
          class="todo-list-item flex flex-vc"
          v-for="item in visitorList"
          :key="item.id"
          @click="handleVisItem(item.id)"
        >
          <div class="todo-left flex">
            <div class="todo">{{ item.type }}</div>
            <div class="date">{{ item.resttime }}</div>
            <div class="date-course">
              {{ item.startTime }} - {{ item.endTime }}
            </div>
          </div>
          <div class="todo-content flex-1">
            <div class="flex">
              <div>{{ item.acceptName }}</div>
              <div
                style="margin-left: 1rem;"
                v-if="item.visitorName && item.visitorName.length > 0"
              >
                共计{{ item.visitorName && item.visitorName.length + 1 }}人
              </div>
            </div>
            <div class="info">拜访目的：{{ item.visitorGoal }}</div>
            <div class="avatar" v-if="item.visitorName.length > 0">
              同行人员：<span
                class=""
                v-for="(v, index) in item.visitorName"
                :key="index"
                >{{ v
                }}<span v-if="index !== item.visitorName.length - 1">
                  /
                </span></span
              >
            </div>
          </div>
          <div class="todo-btn" @click.stop="handleVisEdit(item.id)">撤销</div>
        </div>
      </div>
      <div v-else>
        <van-empty description="暂无数据" />
      </div>
    </div>
    <template v-if="dolist.length > 0">
      <div class="title">
        审批通过
      </div>

      <div class="do-list">
        <div>
          <div
            class="do-list-item flex"
            v-for="item in dolist"
            :key="item.id"
            @click="handleVisItem(item.id)"
          >
            <div class="flex flex-b">
              <span class="do-title mb">{{ item.acceptName }}</span>
              <span style="font-size: 0.75rem;" @click.stop="handleVis(item.id)"
                >再次预约</span
              >
            </div>
            <div class="mb" style="font-size: 0.75rem;">
              <span style="margin-right: 0.3rem;">{{ item.resttime }}</span>
              <span>{{ item.startTime }}-{{ item.endTime }}</span>
            </div>
            <div v-if="item.visitorName && item.visitorName.length > 0">
              <div style="font-size: 0.75rem;">
                共计{{ item.visitorName && item.visitorName.length + 1 }}人
                <span class="" v-for="(v, index) in item.visitorName"
                  >{{ v
                  }}<span v-if="index !== item.visitorName.length - 1">
                    /
                  </span></span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </template> -->
  </div>
</template>

<script>
import moment from 'moment'
moment.locale('zh-cn')
import assign from '@/mixins/assign'

export default {
  data() {
    return {
      visitorList: [],
      dolist: [],
      list: [],
    }
  },
  mixins: [assign],

  mounted() {
    // this.getVisitorList()
    this.getList()
  },
  methods: {
    clickNavBarRight() {
      this.$router.push('/subscribe')
    },
    getList() {
      Promise.all([
        this.getVisitorList(0),
        this.getVisitorList(1),
        this.getVisitorList(2),
        // this.getVisitorList(-1),
      ]).then((res) => {
        console.log(res)
        res.forEach((item) => {
          item.forEach((v) => {
            v.resttime = moment(v.visitorBeginTime).format('YYYY.MM.DD')
            v.startTime = moment(v.visitorBeginTime).format('HH:mm')
            v.endTime = moment(v.visitorEndTime).format('HH:mm')
            this.list.push(v)
          })
        })
      })
    },
    async getVisitorList(status) {
      const { data, code, msg } = await this.$https.getVisitorList({
        userId: this.$store.state.userId,
        auditStatus: status,
      })
      if (code !== 200) {
        this.$toast(msg)
        return false
      }
      return Promise.resolve(data || [])
    },

    // if (data) {
    //   this.visitorList = data.map((item) => {
    //     item.type = this.nType(item.auditStatus)
    //     item.resttime = moment(item.visitorBeginTime).format('YYYY.MM.DD')
    //     item.startTime = moment(item.visitorBeginTime).format('HH:mm')
    //     item.endTime = moment(item.visitorEndTime).format('HH:mm')
    //     item.visitorGoal = item.visitorGoal || '暂未填写'
    //     return item
    //   })
    // } else {
    //   this.visitorList = []
    // }
    // async getVisitorList() {
    //   const { data, code, msg } = await this.$https.getVisitorList({
    //     userId: this.$store.state.userId,
    //     auditStatus: 0,
    //   })
    //   if (code !== 200) {
    //     this.$toast(msg)
    //     return false
    //   }
    //   if (data) {
    //     this.visitorList = data.map((item) => {
    //       item.type = this.nType(item.auditStatus)
    //       item.resttime = moment(item.visitorBeginTime).format('YYYY.MM.DD')
    //       item.startTime = moment(item.visitorBeginTime).format('HH:mm')
    //       item.endTime = moment(item.visitorEndTime).format('HH:mm')
    //       item.visitorGoal = item.visitorGoal || '暂未填写'
    //       return item
    //     })
    //   } else {
    //     this.visitorList = []
    //   }
    // },
    // async getList() {
    //   const { data, code, msg } = await this.$https.getVisitorList({
    //     userId: this.$store.state.userId,
    //     auditStatus: 1,
    //   })
    //   if (code !== 200) {
    //     this.$toast(msg)
    //     return false
    //   }
    //   if (data) {
    //     this.dolist = data.map((item) => {
    //       item.type = this.nType(item.auditStatus)
    //       item.resttime = moment(item.visitorBeginTime).format('YYYY.MM.DD')
    //       item.startTime = moment(item.visitorBeginTime).format('HH:mm')
    //       item.endTime = moment(item.visitorEndTime).format('HH:mm')
    //       item.visitorGoal = item.visitorGoal
    //       return item
    //     })
    //   } else {
    //     this.dolist = []
    //   }
    // },
    nType(item) {
      const obj = {
        '-1': '已失效',
        '0': '待审核',
        '1': '已审核',
        '2': '驳回',
        '3': '已完成',
      }
      return obj[item]
    },
    handleVisItem(id) {
      this.$router.push({ path: '/detailSub', query: { id, type: 'vis' } })
    },
    handleVisEdit(id) {
      // const { data, code, msg } = await this.$https.undoVisitor({
      //   id,
      //   userId: this.$store.state.userId,
      // })
      // if (code !== 200) {
      //   this.$toast(msg)
      //   return
      // }
      this.$dialog
        .confirm({
          title: '温馨提示',
          message: '您确定要撤回该记录吗？',
        })
        .then(() => {
          // on confirm
          return this.$https.undoVisitor({
            id,
            userId: this.$store.state.userId,
          })
        })
        .then(({ code, data, msg }) => {
          if (code !== 200) {
            this.$toast(msg)
            return
          }
          this.$toast('撤销成功')
          // this.getVisitorList()
          this.getList()
        })
        .catch(() => {
          // on cancel
        })
      // this.$router.push({ path: '/updateSub', query: { id } })
    },
    handleVis(id) {
      this.$router.push({ path: '/Subscribe', query: { id, type: 'again' } })
    },
  },
  components: {},
}
</script>

<style scoped lang="scss">
.list {
  /* padding: 1.5rem 0; */
  margin: 1rem;
  .list-item {
    display: flex;
    flex-direction: column;
    background: #fff;
    margin-bottom: 0.63rem;
    border-radius: 0.75rem;
    position: relative;
    &::after,
    &::before {
      content: '';
      width: 1rem;
      height: 1rem;
      background: #f7f7fa;
      border-radius: 50%;
      position: absolute;
      top: 2.6rem;
    }
    &::after {
      right: -0.5rem;
    }
    &::before {
      left: -0.5rem;
    }
    .top {
      padding: 0.88rem 0;
      margin: 0 0.75rem;
      border-bottom: 1px dashed #d9dee9;
      font-size: 1rem;
      /* .status {
        background: rgba(52, 151, 253, 0.13);
        border-radius: 50%;
        color: #3497fd;
        display: inline-block;
        width: 1.5rem;
        height: 1.5rem;
        text-align: center;
        line-height: 1.5rem;
        font-size: 0.75rem;
      } */
      .top-text {
        display: inline-block;
        vertical-align: middle;
        margin-left: 1.31rem;
        font-size: 0.88rem;
        color: #78849e;
      }
    }
    .content {
      margin: 0 0.75rem;
      padding: 0.81rem 0;
      display: flex;
      align-items: center;
      .avatar {
        width: 2.88rem;
        height: 2.88rem;
        margin-right: 0.81rem;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 50%;
        }
      }
      .info {
        flex: 1;
        color: #959dad;
        .info-1 {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 0.88rem;
          .btn {
            background: rgba(52, 151, 253, 0.13);
            color: #3497fd;
            width: 3.88rem;
            height: 1.56rem;
            border-radius: 2rem;
            text-align: center;
            line-height: 1.56rem;

            font-size: 0.81rem;
          }
        }
      }
    }
    .count {
      color: #959dad;
      margin: 0 0.75rem;
      font-size: 0.75rem;
      padding-bottom: 0.81rem;
    }
  }
}
.title {
  font-size: 0.75rem;
  color: #78849e;
  margin: 1rem;
}
.visitor {
  /* padding-bottom: 50pxpad; */
  .visitor-top {
    height: 6.1875rem;
    background: rgba(42, 46, 67, 1);
    width: 100%;
  }
  .visitor-content {
    /* margin-top: -4.875rem; */
    /* background: #fff; */
    /* border-radius: 1.0625rem;
    margin-top: 0.8125rem;
    padding: 1.5rem 0;
    margin: 0 1rem; */
    /* padding: 0 1rem; */
    border-radius: 0.75rem;
    margin: 0 1rem;
    /* background: #fff; */
    .post {
      .post-item {
        background: rgba(53, 58, 80, 1);
        border-radius: 0.5rem;
        width: 10.75rem;
        height: 2.5625rem;
        padding: 0 1rem;
        .count {
          font-size: 1.125rem;
        }
        .text {
          margin-left: 0.75rem;
          color: rgba(255, 255, 255, 1);
          opacity: 0.56;
          font-size: 0.75rem;
        }
        img {
          width: 1.1rem;
          height: 1.1rem;
        }
      }
    }
  }
  .todo-list {
    background: #fff;
    border-radius: 1.0625rem;
    /* margin-top: 0.8125rem; */
    /* height: 200px; */

    padding: 1.5rem 0;
    .todo-list-item {
      margin-bottom: 1.5rem;
      padding: 0 0.75rem;
      color: rgba(149, 157, 173, 1);
      &:last-child {
        margin-bottom: 0;
      }
      .todo-left {
        flex-direction: column;
        align-items: center;
        .todo {
          background: rgba(52, 151, 253, 1);
          /* width: 1.5rem; */
          height: 1.5rem;
          color: #fff;
          text-align: center;
          line-height: 1.5rem;
          font-size: 0.75rem;
          border-radius: 0.5rem;
          margin-bottom: 0.625rem;
          padding: 0 0.3rem;
        }
        .date {
          margin-bottom: 0.3125rem;
          font-size: 0.75rem;
          font-weight: 400;
          color: rgba(120, 132, 158, 1);
        }
        .date-course {
          font-size: 0.5625rem;
        }
      }
    }
    .todo-content {
      font-size: 0.75rem;
      font-weight: 400;
      margin-left: 0.5rem;
      .info {
        margin-top: 0.25rem;
      }
      .avatar {
        margin-top: 0.4875rem;
        /* text-overflow; */
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        max-width: 12rem;
      }
      img {
        width: 2rem;
        height: 2rem;
        border-radius: 50%;
        margin-right: 0.5rem;
      }
    }
    .todo-btn {
      width: 2.6875rem;
      height: 2.6875rem;
      text-align: center;
      line-height: 2.6875rem;
      font-size: 0.75rem;
      border-radius: 0.5rem;
      color: #fff;
      margin-left: 0.3rem;
      box-shadow: 0 0.75rem 1rem rgba(69, 91, 99, 0.1);
      background: #3acce1;
      /* margin-right: 0.75rem; */
    }
  }
}
.menu {
  margin: 0 1rem;
}
.do-list {
  margin-top: 1rem;
  border-radius: 0.75rem;
  background-color: #fff;
  margin: 0rem 1rem 0;
  .do-list-item {
    color: #78849e;
    flex-direction: column;
    margin: 0 0.8125rem;
    padding-top: 1.375rem;
    padding-bottom: 0.875rem;
    border-bottom: 1px solid #f4f4f6;
    .do-title {
      color: #454f63;
      font-size: 1rem;
      font-weight: 400;
    }
    .mb {
      margin-bottom: 0.25rem;
    }
  }
}
.form-bg-title {
  padding: 0.6rem 1rem 0;
  height: 5.7rem;
  width: 100%;
  .img {
    background: url('../../assets/images/banner.png') no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 100%;
  }
  .company {
    color: #fff;
    font-size: 1.125rem;
    font-weight: 400;
    margin-bottom: 0.1875rem;
  }
  .welcome {
    color: rgba(255, 255, 255, 0.5);
    font-size: 0.75rem;
  }
}
</style>
